import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { TaskItem } from '../../taskcommon/taskcommon.class';
import { TaskOrder } from './taskorders';

const API = '/api/construction-projects/v1/cockpit-taskorders/';

@Injectable({ providedIn: 'root' })
export class TaskOrderService {

  taskOrder: TaskOrder = new TaskOrder();
  taskOrders: TaskOrder[] = [];

  constructor(private apiCockpit: APISCockpit) { }

  async GetTaskOrder(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id;
      this.taskOrders = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.taskOrders.length > 0) {
        this.taskOrder = this.taskOrders[0];
      }
    }
    return this.taskOrder;
  }

  async GetTaskOrderByInput(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id + '/byinput/' + itm.inputId;
      this.taskOrders = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.taskOrders.length > 0) {
        this.taskOrder = this.taskOrders[0];
      }
    }
    return this.taskOrder;
  }

}
